import script from "./ApprovalDetailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ApprovalDetailModal.vue?vue&type=script&setup=true&lang=js"

import "./ApprovalDetailModal.vue?vue&type=style&index=0&id=a1d4bae8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1d4bae8"]])

export default __exports__